import { addVisible, removeVisible } from './helper';

const CLS = '.validate--tooltip-min';
export function validateMin(element: HTMLInputElement, min: number): boolean {
    if (parseInt(element.value, 10) < min) {
        addVisible(element, CLS);
        return false;
    } else {
        removeVisible(element, CLS);
        return true;
    }
}
export function liveValidateMin(element: HTMLInputElement) {
    const min = parseInt(element.getAttribute('min') as string, 10);
    if (isNaN(min)) {
        return;
    }
    element.addEventListener('input', (e: Event) => {
        return validateMin(element, min);
    });
    element.addEventListener('change', (e: Event) => {
        return validateMin(element, min);
    });
    element.addEventListener('blur', (e: Event) => {
        return validateMin(element, min);
    });
}
